<template>
  <div>
    <CRow>
      <CCol class="col-md-5 col-12">
        <CCard class="col-md-12">
          <CRow class="p-3">
            <h4 class="color-light ml-2 page_title"><span class="ul_text">AC</span>COUNT SETTING</h4>
          </CRow>
          <CCardBody>
            <account-setting :account="account" :onSubmit="onSubmitAccount"></account-setting>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-md-7 col-12">
        <CRow>
          <CCard class="col-md-12 p-3">
            <CRow>
              <CCol>
                <h4 class="color-light page_title"><span class="">Time Zone </span></h4>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol class="col-md-6 col-12">
                <CSelect required :value.sync="timezone" :options="timezone_list" />
              </CCol>
              <CCol>
                <CButton color="success" type="submit" v-on:click="updateTimeZone(timezone)">Save</CButton>
              </CCol>
            </CRow>
          </CCard>
        </CRow>
        <CRow>
          <CCard class="col-md-12 p-3">
            <CRow>
              <CCol>
                <h4 class="color-light page_title">Report Recipients :</h4>
                <CRow class="mt-3">
                  <!-- <CCol class="col-md-1 text-right"> -->
                  <span class="ml-3 f-10">Enable Hourly Report :</span>
                  <!-- </CCol> -->
                  <CCol class="col-md-1">
                    <CSwitch color="success" labelOn="ON" labelOff="OFF" :checked="recipients.hourlyReport"
                      :disabled="loading" @update:checked="enableHourlyReport()"></CSwitch>
                  </CCol>
                </CRow>
                <CRow class="mt-2">
                  <CCol>
                    <span class="f-10">Enter recipient's email:</span>
                    <multiselect
                      v-model="recipients.reportRecipients"
                      :options="recipients.reportRecipients"
                      :multiple="true"
                      :taggable="true"
                      @tag="addHourlyEmailTag"
                      :clear-on-select="false"
                      :close-on-select="false"
                      placeholder="Type email and press enter to add..."
                      :preselect-first="false"
                      :hide-selected="false"
                      tag-placeholder="Press enter to add this email"
                      :limit="2"
                      :limit-text="count => `and ${count} more`"
                    ></multiselect>
                  </CCol>
                </CRow>
                <CRow class="mt-2">
                  <CCol>
                    <CButton color="success" type="submit" v-on:click="updateRecipients()" :disabled="loading">Save
                    </CButton>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCard>
        </CRow>
      </CCol>
    </CRow>

    <CCard class="col-md-12 p-3">
      <CRow>
        <CCol>
          <h4 class="color-light page_title"><span class="">Inactivity TimeOut </span><small> (minutes)</small></h4>
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol class="col-md-3 col-12">
          <CInput size="sm" id="inactivityDuration" v-model="inactivityDuration" type="number" required
            placeholder="Enter Minutes for Logout Timeout"></CInput>
        </CCol>
        <CCol>
          <CButton color="success" type="submit" v-on:click="setLogoutTimeout" :disabled="loading">Save</CButton>
        </CCol>
      </CRow>
    </CCard>
    <CCard class="col-md-12 p-3">
      <CRow>
        <CCol>
          <h4 class="color-light page_title"><span class="">Custom CG Host </span></h4>
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol class="col-md-3 col-12">
          <CInput size="sm" id="cghost" v-model="customCGHost"
            placeholder="Enter Custom CG Host"></CInput>
        </CCol>
        <CCol>
          <CButton color="success" type="submit" v-on:click="setCustomHost" :disabled="loading">Save</CButton>
        </CCol>
      </CRow>
    </CCard>
    <CCard class="col-md-12 p-3" v-if="user == 'user'">
      <CRow>
        <CCol>
          <h4 class="color-light page_title"><span class="">SUB Value Mapping </span></h4>
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol class="col-md-1 col-12">
          <!-- <CLabel>Select Sub</CLabel> -->
          <CSelect size="sm" id="subValue" :options="subValueOpt" v-model="subValue.key" required></CSelect>
        </CCol>
        <CCol class="col-md-3 col-12">
          <!-- <CLabel>Sub Value</CLabel> -->
          <CInput size="sm" id="subValue" v-model="subValue.value" type="text" required placeholder="Enter Sub Value">
          </CInput>
        </CCol>
        <CCol>
          <CButton color="success" type="submit" v-on:click="saveSubValue()">Save</CButton>
        </CCol>
      </CRow>
      <CRow class="mt-3" v-if="showSubVal">
        <CCol>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Sub</th>
                <th>Value</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in mappedSubValue">
                <td>{{ key }}</td>
                <td>{{ value }}</td>
                <td>
                  <CButton color="info" size="sm" @click="editSub(key, value)">Edit</CButton>
                  <CButton class="ml-2" color="danger" size="sm" @click="deleteSub(key)">Delete</CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
      </CRow>

    </CCard>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import SettingService from "./../../services/settingControlService";
import AccountSetting from "./../../components/setting/AccountSetting";
import LoginService from './../../services/loginControlService'
import { CRow, CSelect, CSwitch } from "@coreui/vue";
import Multiselect from "vue-multiselect";
import DashboardService from "./../../services/dashboardController";
import helperFunction from '../../helper/helperFunction';
export default {
  components: { AccountSetting, Multiselect },
  data() {
    return {
      loading: false,
      recipients: { hourlyReport: false, reportRecipients: [] },
      timezone: '',
      timezone_list: Intl.supportedValuesOf('timeZone'),
      user: "",
      customCGHost: "",
      account: { current_password: '', new_password: '', confirm_password: '' },
      inactivityDuration: 60, // 5 minutes (in milliseconds),
      subValueOpt: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6', 'sub7', 'sub8', 'sub9', 'sub10', 'sub11', 'sub12'],
      subValue: { key: 'sub1', value: '' },
      mappedSubValue: {},
      showSubVal: true,
      filter_dash: {},
      dailyReportSettings: {
        dailyReport: false,
        reportRecipientsForAuto: [],
        selectedCampaigns: [],
        selectedGroupBy: [
          { value: "campname", text: "Campaign" }
        ],
        selectedMetrics: [
          { value: "browse", text: "Click" },
          { value: "impression", text: "Impression" },
          { value: "accepted", text: "Valid" },
          { value: "discarded", text: "Discarded" },
          { value: "rejected", text: "Invalid" },
          { value: "converted", text: "Converted" },
          { value: "convertedRate", text: "Conversion Rate" },
          { value: "rejectedRate", text: "Invalid Rate" },
          { value: "acceptedRate", text: "Valid Rate" }
        ],
        reportFrequency: { value: 'daily', text: 'Daily' },
        reportProjections: [],
        reportMetrics: [],
        reportDimensions: {
          camp_id: []
        }
      },
      frequencyOptions: [
        { value: 'hourly', text: 'Hourly' },
        { value: 'daily', text: 'Daily' },
        { value: 'weekly', text: 'Weekly' }
      ],
      campaignOptions: [],
      camp_list: {},
      pendingCampaignIds: null,
      projectionOptions: [
        { value: "campname", text: "Campaign" },
        { value: "offerid", text: "Offer" },
        { value: "tsid", text: "TrafficSource" },
        { value: "country", text: "Country" },
        { value: "browser", text: "Browser" },
        { value: "os", text: "Operating System" },
        { value: "devicetype", text: "Device Type" },
        { value: "networktype", text: "Network Type" },
        { value: "packageid", text: "Package Id"},
        { value: "external_id", text: "External Id" },
        { value: "carrier", text: "Carrier" },
        { value: "languages", text: "Languages" },
        { value: "timezone", text: "TimeZone" },
        { value: "make", text: "Make" },
        { value: "model", text: "Model" },
        { value: "eventMessage", text: "Event Message" },
        { value: "qp_sub1", text: "Sub1" },
        { value: "qp_sub2", text: "Sub2" },
        { value: "qp_sub3", text: "Sub3" },
        { value: "qp_sub4", text: "Sub4" },
        { value: "qp_sub5", text: "Sub5" },
        { value: "qp_sub6", text: "Sub6" },
        { value: "qp_sub7", text: "Sub7" },
        { value: "qp_sub8", text: "Sub8" },
        { value: "qp_sub9", text: "Sub9" },
        { value: "qp_sub10", text: "Sub10" },
        { value: "qp_sub11", text: "Sub11" },
        { value: "qp_sub12", text: "Sub12" }
      ],

      
      metricsOptions: [
        { value: "browse", text: "Click" },
        { value: "render", text: "Render" },
        { value: "impression", text: "Impression" },
        { value: "accepted", text: "Valid" },
        { value: "discarded", text: "Discarded" },
        { value: "rejected", text: "Invalid" },
        { value: "convertedRate", text: "Conversion Rate" },
        { value: "converted", text: "Converted" },
        { value: "offerrev", text: "Offer Revenue" },
        { value: "camprev", text: "Campaign Revenue" },
        { value: "event", text: "Event Count" },
        { value: "renderRate", text: "Render Rate" },
        { value: "impressionRate", text: "Impression Rate" },
        { value: "rejectedRate", text: "Invalid Rate" },
        { value: "acceptedRate", text: "Valid Rate" }
      ]
    };
  },
  async mounted() {
    if (
      window.localStorage.getItem("user") &&
      window.localStorage.getItem("status") != "true"
    ) {
      this.$router.push("/");
    } else {
      if (window.localStorage.getItem("user")) {
        this.user = window.localStorage.getItem("user")
      }
      // this.useremail = window.localStorage.getItem("email");
      if (window.localStorage.getItem('logoutTimeout')) {
        let logoutTimeout = window.localStorage.getItem('logoutTimeout')
        this.inactivityDuration = logoutTimeout / (1000 * 60);
        this.inactivityDuration = parseInt(this.inactivityDuration)
      }
      if (localStorage.getItem("filter_dash1")) {
        this.filter_dash = JSON.parse(localStorage.getItem("filter_dash1"));
      }
      // First get sub values, then fetch campaigns
      // The order is important to ensure projection options are updated with mapped values
      await this.getSubValue()
      this.fetchCampaigns()
      // let mappedSubValue = window.localStorage.getItem('subValueMappping')
      // if(mappedSubValue){
      //   this.mappedSubValue = JSON.parse(mappedSubValue)
      // }
      if (!this.timezone_list.includes('UTC')) {
        this.timezone_list.push('UTC')
      }
    }
  },
  methods: {
    async enableHourlyReport() {
      this.loading = true
      this.recipients.hourlyReport = !this.recipients.hourlyReport
      let payload = {
        "hourlyReport": this.recipients.hourlyReport
      }
      let response = await SettingService.updateRecipients(payload)
      if (response.result) {
        Swal.fire({ title: "Success!", text: response.message, icon: "success", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
      else {
        Swal.fire({ title: "Error!", text: response.message, icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
      this.loading = false
    },
    async updateRecipients() {
      this.loading = true
      let payload = {
        "reportRecipients": this.recipients.reportRecipients
      }
      let response = await SettingService.updateRecipients(payload)
      if (response.result) {
        Swal.fire({ title: "Success!", text: response.message, icon: "success", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
      else {
        Swal.fire({ title: "Error!", text: response.message, icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
      this.loading = false
    },
    async updateTimeZone() {
      let response = await SettingService.updateTimeZone({ "timezone": this.timezone })
      if (response.result) {
        Swal.fire({ title: "Success!", text: response.message, icon: "success", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
      else {
        Swal.fire({ title: "Error!", text: response.message, icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
    },
    async getSubValue() {
      let response = await SettingService.getSubValue()
      if (response.result == true) {
        this.customCGHost = response.data.customCGHost ? response.data.customCGHost : ''
        this.mappedSubValue = response.data.subValueMappping
        this.timezone = response.data.timezone ? response.data.timezone : 'UTC'
        this.recipients.hourlyReport = response.data.hourlyReport ? response.data.hourlyReport : false
        this.recipients.reportRecipients = response.data.reportRecipients ? response.data.reportRecipients : []
        
        // Set auto report settings if they exist
        if (response.data.autoReportSetting) {
          const autoSettings = response.data.autoReportSetting;
          this.dailyReportSettings.dailyReport = autoSettings.enable === "true";
          this.dailyReportSettings.reportRecipientsForAuto = autoSettings.reportRecipientsForAuto || [];
          
          // Set frequency
          if (autoSettings.reportFrequency) {
            const frequencyOption = this.frequencyOptions.find(f => f.value === autoSettings.reportFrequency);
            if (frequencyOption) {
              this.dailyReportSettings.reportFrequency = frequencyOption;
            }
          }
          
          // Set selected group by (projections)
          if (autoSettings.reportProjections && autoSettings.reportProjections.length > 0) {
            this.dailyReportSettings.selectedGroupBy = autoSettings.reportProjections.map(proj => {
              const option = this.projectionOptions.find(p => p.value === proj);
              return option || { value: proj, text: proj };
            });
          }
          
          // Set selected metrics
          if (autoSettings.reportMetrics && autoSettings.reportMetrics.length > 0) {
            this.dailyReportSettings.selectedMetrics = autoSettings.reportMetrics.map(metric => {
              const option = this.metricsOptions.find(m => m.value === metric);
              return option || { value: metric, text: metric };
            });
          }
          
          // Set selected campaigns - need to wait for campaigns to be loaded
          if (autoSettings.reportDimensions && autoSettings.reportDimensions.camp_id) {
            // Store the campaign IDs to be set after campaigns are loaded
            this.pendingCampaignIds = autoSettings.reportDimensions.camp_id;
          }
        }
        
        // Update projection options with mapped sub values
        if (this.mappedSubValue && typeof this.mappedSubValue === 'object') {
          Object.keys(this.mappedSubValue).forEach((key) => {
            this.projectionOptions.map(item => {
              if (item.value === 'qp_' + key) {
                item.text = this.mappedSubValue[key];
              }
            });
          });
        }
      }
    },
    editSub(key, value) {
      this.subValue.key = key
      this.subValue.value = value
    },
    deleteSub(key) {
      if (confirm('Are you sure you want to delete this sub value?')) {
        let mappedSubValue = this.mappedSubValue
        delete mappedSubValue[key]
        let payload = { 'subValueMappping': mappedSubValue }
        this.subValueAPiCall(payload)
      }
    },
    saveSubValue() {
      if (this.subValue.value == '') {
        Swal.fire({ title: "Error!", text: "Please enter sub value", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      let mappedSubValue = this.mappedSubValue || {};
      mappedSubValue[this.subValue.key] = this.subValue.value
      let payload = { 'subValueMappping': mappedSubValue }
      this.subValueAPiCall(payload)
    },
    async subValueAPiCall(payload) {
      let response = await SettingService.saveSubValue(payload)
      if (response.result == true) {
        this.subValue.value = ''
        this.showSubVal = false
        this.mappedSubValue = payload.subValueMappping
        
        // Update projection options with new mapped values
        if (payload.subValueMappping && typeof payload.subValueMappping === 'object') {
          Object.keys(payload.subValueMappping).forEach((key) => {
            this.projectionOptions.map(item => {
              if (item.value === 'qp_' + key) {
                item.text = payload.subValueMappping[key];
              }
            });
          });
        }
        
        // Update filter_dash if it exists
        this.filter_dash = JSON.parse(localStorage.getItem("filter_dash1"));
        if (this.filter_dash) {
          if (this.filter_dash.projectionopt && this.filter_dash.projectionopt.length > 0) {
            this.filter_dash.projectionopt.map((item) => {
              if (item.value.startsWith('qp_')) {
                let key = item.value.substring(3);
                if (payload.subValueMappping[key]) {
                  item.text = payload.subValueMappping[key]
                }
                else {
                  item.text = key
                }
              }
            });
          }
        }
        Swal.fire({ title: "Success!", text: response.message, icon: "success", position: 'top-end', showConfirmButton: false, timer: 1000 });
        this.getSubValue();
        this.showSubVal = true
        return true;
      }
      else {
        Swal.fire({ title: "Error!", text: response.message, icon: "error", position: 'top-end', showConfirmButton: false, timer: 1000 });
        return false;
      }
    },
    setupLogoutTimer() {
      // Clear existing timeout, if any
      clearTimeout(this.logoutTimeout);
      // Set up a new timeout for logout
      this.logoutTimeout = setTimeout(() => {
        this.logout()
      }, this.inactivityDuration);
    },
    async setCustomHost() {

      if (this.customCGHost == "" || helperFunction.validateDomains(this.customCGHost) ) {
        let payload = { "customCGHost": this.customCGHost }
        let response = await SettingService.setCustomCGHost(payload)
        if (response.result == true) {
          Swal.fire({ title: "Success!", text: response.message, icon: "success", position: 'top-end', showConfirmButton: false, timer: 2000 });
        }
        else {
          Swal.fire({ title: "Error!", text: response.message, icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        }
      } else {
          Swal.fire({ title: "Error!", text: "Please enter valid custom CG host", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
          return false;
      }
      
    },
    async setLogoutTimeout() {
      let payload = { "timeout": this.inactivityDuration * 60 * 1000 }
      let response = await SettingService.setLogoutTimeout(payload)
      if (response.result == true) {
        Swal.fire({ title: "Success!", text: response.message, icon: "success", position: 'top-end', showConfirmButton: false, timer: 2000 });
        window.localStorage.setItem('logoutTimeout', this.inactivityDuration * 60 * 1000)
        // this.setupLogoutTimer();
      }
      else {
        Swal.fire({ title: "Error!", text: response.message, icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
      }
    },
    async onSubmitAccount() {
      if (this.validate()) {
        let account_data = {
          oldpassword: this.account.current_password,
          newpassword: this.account.new_password,
        };
        let response = await SettingService.resetpwd(account_data);
        if (response.result == true) {
          Swal.fire({
            title: "Success!",
            text: response.message + "...Logging OUT",
            icon: "success",
            confirmButtonText: "Close", position: 'top-end', showConfirmButton: false, timer: 1000
          });
          window.setTimeout(() => {
            this.logout();
          }, 5000);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.message,
            icon: "error",
            confirmButtonText: "Close", position: 'top-end', showConfirmButton: false, timer: 1000
          });
        }
        // this.errorNotify("Success", "Password Changed...Logging OUT", "success");

        // this.$router.push('Login')
      }
    },
    validate() {
      if (this.account.new_password && this.account.new_password.length < 6) {
        Swal.fire({ title: "Error!", text: "Please use minimum 6 digit password", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      else if (this.account.current_password == "") {
        Swal.fire({ title: "Error!", text: "Please Enter Current password.", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      else if (this.account.new_password == "") {
        Swal.fire({ title: "Error!", text: "Please Enter New password.", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      else if (this.account.confirm_password == "") {
        Swal.fire({ title: "Error!", text: "Please Enter Confirm password.", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      else if (this.account.new_password != this.account.confirm_password) {
        Swal.fire({ title: "Error!", text: "New password and Confirm password are not the same.", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      else if (this.account.current_password == this.account.new_password) {
        Swal.fire({ title: "Error!", text: "Current password and New password should be different.", icon: "error", position: 'top-end', showConfirmButton: false, timer: 2000 });
        return false;
      }
      else {
        return true;
      }
    },
    async enableDailyReport() {
      this.loading = true;
      this.dailyReportSettings.dailyReport = !this.dailyReportSettings.dailyReport;
      
      // Prepare minimal payload for enable/disable
      const payload = {
        autoReportSetting: {
          enable: this.dailyReportSettings.dailyReport ? "true" : "false",
          reportRecipientsForAuto: this.dailyReportSettings.reportRecipientsForAuto,
          reportFrequency: this.dailyReportSettings.reportFrequency.value,
          reportProjections: this.dailyReportSettings.selectedGroupBy.map(item => item.value),
          reportMetrics: this.dailyReportSettings.selectedMetrics.map(item => item.value),
          reportDimensions: {
            camp_id: this.dailyReportSettings.selectedCampaigns.map(campaign => campaign.value)
          }
        }
      };
      
      let response = await SettingService.updateRecipients(payload);
      if (response.result) {
        Swal.fire({ 
          title: "Success!", 
          text: response.message, 
          icon: "success", 
          position: 'top-end', 
          showConfirmButton: false, 
          timer: 2000 
        });
      } else {
        // Revert the toggle if API call fails
        this.dailyReportSettings.dailyReport = !this.dailyReportSettings.dailyReport;
        Swal.fire({ 
          title: "Error!", 
          text: response.message, 
          icon: "error", 
          position: 'top-end', 
          showConfirmButton: false, 
          timer: 2000 
        });
      }
      this.loading = false;
    },
    async fetchCampaigns() {
      try {
        let response = await DashboardService.camplist({
          useremail: this.useremail || window.localStorage.getItem("email")
        });
        if (response.result) {
          this.camp_list = response.message.campaign;
          // Convert camp_list object to options array
          // key = campaign ID, value = campaign name
          // We show campaign names to users and also send names in payload
          this.campaignOptions = [];
          // alert(JSON.stringify(this.camp_list))
          for(let [campaignName, campaignId] of Object.entries(this.camp_list)) {
          
            this.campaignOptions.push({ 
              value: campaignId,  // This is what we track and send in payload
              text: campaignName    // This is what users see
            });
          }
          
          // If there are pending campaign IDs from saved settings, set them now
          if (this.pendingCampaignIds && this.pendingCampaignIds.length > 0) {
            this.dailyReportSettings.selectedCampaigns = this.pendingCampaignIds.map(campId => {
              const option = this.campaignOptions.find(c => c.value === campId);
              return option || null;
            }).filter(item => item !== null);
            this.pendingCampaignIds = null; // Clear pending IDs
          }
        }
      } catch (e) {
        console.error("Error in getting camplist", e);
      }
    },
    async saveDailyReportSettings() {
      this.loading = true;
      // Prepare the payload according to the API format
      const payload = {
        autoReportSetting: {
          enable: this.dailyReportSettings.dailyReport ? "true" : "false",
          reportRecipientsForAuto: this.dailyReportSettings.reportRecipientsForAuto,
          reportFrequency: this.dailyReportSettings.reportFrequency.value,
          reportProjections: this.dailyReportSettings.selectedGroupBy.map(item => item.value),
          reportMetrics: this.dailyReportSettings.selectedMetrics.map(item => item.value),
          reportDimensions: {
            camp_id: this.dailyReportSettings.selectedCampaigns.map(campaign => campaign.value)
          }
        }
      };
      
      // Use the same updateRecipients API method
      let response = await SettingService.updateRecipients(payload);
      if (response.result) {
        Swal.fire({ 
          title: "Success!", 
          text: response.message, 
          icon: "success", 
          position: 'top-end', 
          showConfirmButton: false, 
          timer: 2000 
        });
      } else {
        Swal.fire({ 
          title: "Error!", 
          text: response.message, 
          icon: "error", 
          position: 'top-end', 
          showConfirmButton: false, 
          timer: 2000 
        });
      }
      this.loading = false;
    },
    addEmailTag(newEmail) {
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(newEmail)) {
        this.dailyReportSettings.reportRecipientsForAuto.push(newEmail);
      } else {
        Swal.fire({ 
          title: "Invalid Email!", 
          text: "Please enter a valid email address", 
          icon: "error", 
          position: 'top-end', 
          showConfirmButton: false, 
          timer: 2000 
        });
      }
    },
    addHourlyEmailTag(newEmail) {
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(newEmail)) {
        this.recipients.reportRecipients.push(newEmail);
      } else {
        Swal.fire({ 
          title: "Invalid Email!", 
          text: "Please enter a valid email address", 
          icon: "error", 
          position: 'top-end', 
          showConfirmButton: false, 
          timer: 2000 
        });
      }
    },
    async logout() {
      let response = await LoginService.logout()
      // swal("Are you sure you want to Logout?", {
      //   buttons: ["No!", "Yes!"]
      // }).then(value => {
      //   if (value == true) {
      window.localStorage.setItem("user", null);
      window.localStorage.setItem("status", null);
      window.localStorage.setItem("email", null);
      this.$router.push("/pages/login");
      //   }
      // });
    },
  },
};
</script>

<style>
/* @import 'vue-multiselect/dist/vue-multiselect.min.css'; */

label {
  text-align: left;
  font-weight: 400;
  color: black;
  font-size: 12px;
}

.multiselect__tags {
  border: 1px solid #e4e7ea;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}

.multiselect__placeholder {
  color: #768192;
  font-size: 0.875rem;
}

.multiselect__single {
  font-size: 0.875rem;
}

.multiselect__option--highlight {
  background: #2eb85c;
  outline: none;
  color: white;
}

.multiselect__option--selected {
  background: #f3f4f7;
  color: #2c384a;
  font-weight: bold;
}

.multiselect__tags {
  border: 1px solid #e4e7ea;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  min-height: 40px;
}

.multiselect__placeholder {
  color: #768192;
  font-size: 0.875rem;
  margin-bottom: 8px;
  padding-top: 2px;
}

.multiselect__single {
  font-size: 0.875rem;
  margin-bottom: 8px;
}

.multiselect__option--highlight {
  background: #2eb85c;
  outline: none;
  color: white;
}

.multiselect__option--selected {
  background: #f3f4f7;
  color: #2c384a;
  font-weight: bold;
}

.multiselect__tag {
  background: #2eb85c;
}

.multiselect__tag-icon:after {
  color: #ffffff;
}

.multiselect__tag-icon:hover {
  background: #239a49;
}

.highlight-required {
  animation: highlight-pulse 1s ease-in-out 3;
  border: 2px solid #dc3545 !important;
  border-radius: 0.25rem;
}

@keyframes highlight-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
</style>